// extracted by mini-css-extract-plugin
export var background = "product-specifications-module--background--8d416";
export var boxIcons = "product-specifications-module--boxIcons--fcd2f";
export var carouselControls = "product-specifications-module--carouselControls--da834";
export var carouselControlsModal = "product-specifications-module--carouselControlsModal--0c5ad";
export var closeBtn = "product-specifications-module--closeBtn--42e9b";
export var disclaimer = "product-specifications-module--disclaimer--ad180";
export var epigraphBtn = "product-specifications-module--epigraphBtn--a9cf7";
export var greyback = "product-specifications-module--greyback--5ab17";
export var helperText = "product-specifications-module--helperText--75e89";
export var hrLineSec = "product-specifications-module--hrLineSec--90438";
export var hrlinefirst = "product-specifications-module--hrlinefirst--7b278";
export var imagesAndActions = "product-specifications-module--imagesAndActions--8b902";
export var imgWrap = "product-specifications-module--imgWrap--02aaf";
export var links = "product-specifications-module--links--19c2c";
export var loaderContainer = "product-specifications-module--loaderContainer--5f2cd";
export var material = "product-specifications-module--material--dfc30";
export var materialData = "product-specifications-module--materialData--e8292";
export var materials = "product-specifications-module--materials--05e86";
export var materialsControls = "product-specifications-module--materialsControls--9285f";
export var modal = "product-specifications-module--modal--1e1f9";
export var motion = "product-specifications-module--motion--4ba48";
export var render = "product-specifications-module--render--b4313";
export var rowClose = "product-specifications-module--rowClose--903ad";
export var rowOpen = "product-specifications-module--rowOpen--a16d7";
export var section = "product-specifications-module--section--ac2a6";
export var smallText = "product-specifications-module--smallText--af13c";
export var spec = "product-specifications-module--spec--9acc1";
export var specData = "product-specifications-module--specData--5bf58";
export var specs = "product-specifications-module--specs--25efb";
export var zoom = "product-specifications-module--zoom--a751a";
export var zoomModal = "product-specifications-module--zoomModal--e4f7a";